import React, { LegacyRef, useState } from "react";
import toast from "react-hot-toast";
import { authApiService } from "../../../../api/api";
import { ReactComponent as PhotoIcon } from "../../../../assets/icons/modal/emptyPhoto.svg";
import { IBrand } from "../../../../types/brands.type";
import { ICategory } from "../../../../types/category.type";
import { IDiscount } from "../../../../types/discount.type";
import { IProductCreateDto } from "../../../../types/product.type";
import { IProductType } from "../../../../types/productType.type";
import { ISelectsInput } from "../../../../types/selects.type";
import { ITags } from "../../../../types/tags.type";
import { skinTypeSelector } from "../../../../utils/createSelector";
import SmallWhiteButton from "../../../buttons/WhiteButton/SmallWhiteButton";
import CustomRadioButton from "../../../inputs/CustomRadioButton/CustomRadioButton";
import SelectChangeListInput from "../../../inputs/SelectChangeListInput/SelectChangeListInput";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import EditInput from "../inputs/EditInput/EditInput";
import SelectInput, { SelectOption } from "../inputs/SelectInput/SelectInput";
import ViewInput from "../inputs/ViewInput/ViewInput";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
  tags: ITags[];
  brands: IBrand[];
  categories: ICategory[];
  types: IProductType[];
  discounts: IDiscount[];
}

const EditProductForm: React.FC<Props> = (props) => {
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<any>("");
  const fileInputRef: LegacyRef<HTMLInputElement> | undefined =
    React.createRef();
  const [name, setName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [shortDescription, setShortDescription] = useState<string>("");
  const [capacity, setCapacity] = useState<string>("");
  const [howToUse, setHowToUse] = useState<string>("");
  const [fullIngredientsList, setFullIngredientsList] = useState<string>("");

  const [price, setPrice] = useState<string>("");
  const [wholeSalePrice, setWholeSalePrice] = useState<string>("");
  const [avaliable, setAvaliable] = useState<boolean>(false);
  const [skinType, setSkinType] = useState<SelectOption>({
    label: "Change skin type",
    value: "none",
  });
  const [tags, setTags] = useState<ISelectsInput[] | null>();
  const [brand, setBrand] = useState<SelectOption>({
    value: "none",
    label: "Оберіть бренд",
  });
  const [category, setCategory] = useState<SelectOption>({
    value: "none",
    label: "Оберіть категорію",
  });
  const [type, setType] = useState<SelectOption>({
    value: "none",
    label: "Оберіть тип",
  });
  const [discount, setDiscount] = useState<SelectOption>({
    value: "none",
    label: "Оберіть дісконт",
  });
  const [imagesUrls, setImagesUrls] = useState<string[]>([]);
  const [imagesFilesUrl, setImagesFilesUrl] = useState<File[]>([]);
  const fileImagesInputRef: LegacyRef<HTMLInputElement> | undefined =
    React.createRef();

  const handleImagesChange = (event: any) => {
    const file = event.target.files[0];
    setImagesFilesUrl((prevState) => [...prevState, file]);

    const reader = new FileReader();
    reader.onloadend = () => {
      if (reader.result && typeof reader.result === "string") {
        setImagesUrls((prevState: string[]) => [
          ...prevState,
          reader.result as string,
        ]);
      }
    };
    reader.readAsDataURL(file);
  };

  const handleImageChange = (event: any) => {
    const file = event.target.files[0];
    setSelectedImage(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewUrl(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleImagesButtonClick = () => {
    if (fileImagesInputRef.current) {
      fileImagesInputRef.current.click();
    }
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const removePhoto = () => {
    setSelectedImage(null);
    setPreviewUrl(null);
  };

  const changePriceCount = (value: string, callback: any) => {
    if (isNaN(Number(value))) {
      toast.error("Поле повинно мати числове значення");
      return;
    }
    callback(value);
  };

  const onClickApply = async () => {
    if (
      name &&
      description &&
      capacity &&
      type.label !== "none" &&
      howToUse &&
      fullIngredientsList &&
      // previewUrl &&
      price &&
      wholeSalePrice &&
      brand.value !== "none" &&
      category.value !== "none" &&
      skinType.value !== "none" &&
      discount.value !== "none"
    ) {
      setIsDisabled(true);

      try {
        let avatar = previewUrl;
        if (selectedImage) {
          const formData = new FormData();
          formData.append("file", selectedImage);
          const response = await authApiService.uploadImage(formData);
          avatar = response.publicUrl;
        }

        const images = [...imagesUrls];
        if (imagesFilesUrl.length > 0) {
          for (const img of imagesFilesUrl) {
            const formData = new FormData();
            formData.append("file", img);
            const response = await authApiService.uploadImage(formData);
            const indexToReplace = images.findIndex((image) =>
              image.startsWith("data:image")
            );

            // Якщо таке посилання знайдено, замінюємо його
            if (indexToReplace !== -1) {
              images[indexToReplace] = response.publicUrl;
            }
          }
        }

        const body: IProductCreateDto = {
          name,
          description,
          shortDescription,
          capacity,
          productType: { id: type.value },
          howToUse,
          fullIngredientsList,
          previewImageUrl: avatar,
          imagesUrls: images,
          price: Number(price),
          wholeSalePrice: Number(wholeSalePrice),
          brand: { id: brand.value },
          category: { id: category.value },
          avaliable,
          skinType: skinType.value,
          discount: { id: discount.value },
        };

        if (tags) {
          body.tags = tags?.map((item) => ({ id: item.id }));
        }

        const response = await authApiService.createProduct(body);
        if (response) {
          props.onApply();
          // props.onClose();
        }
      } catch (err: any) {
        toast.error(err.message);
        console.error(err);
      }
    } else {
      toast.error("Всі поля обовʼязкові");
    }
    setIsDisabled(false);
  };

  return (
    <div className={styles.container}>
      <div className={`${styles.headerContainer}`}>
        <div className={styles.photoContainer}>
          <span className={styles.title}>Превью фото</span>
          {previewUrl ? (
            <img src={previewUrl} alt="employee" className={styles.image} />
          ) : (
            <PhotoIcon />
          )}

          <input
            id="file-upload"
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            ref={fileInputRef}
            className={styles.input}
          />
          <SmallWhiteButton
            onClick={previewUrl ? removePhoto : handleButtonClick}
            title={previewUrl ? "Прибрати фото" : "Додати фото"}
          />
        </div>
        <span className={styles.title}>Фото товару</span>

        <div className={styles.imgContainer}>
          {imagesUrls.length === 0 ? (
            <PhotoIcon />
          ) : (
            imagesUrls.map((url, index) => (
              <div className={styles.img}>
                <img src={url} alt="product" className={styles.image} />
                <SmallWhiteButton
                  onClick={() => {
                    setImagesUrls((prevState) =>
                      prevState.filter((_, indx) => indx !== index)
                    );
                  }}
                  title={"Прибрати фото"}
                />
              </div>
            ))
          )}
        </div>
        <div className={styles.addButtonContainer}>
          <input
            id="file-upload"
            type="file"
            accept="image/*"
            onChange={handleImagesChange}
            ref={fileImagesInputRef}
            className={styles.input}
          />
          <SmallWhiteButton
            onClick={handleImagesButtonClick}
            title={"Додати фото"}
          />
        </div>
      </div>

      <>
        <form className={styles.form}>
          <EditInput
            title="Назва"
            value={name}
            setValue={(value) => setName(value)}
            isRequired
          />
          <EditInput
            title="Опис"
            value={description}
            setValue={(value) => setDescription(value)}
            isRequired
            isBig={true}
          />
          <EditInput
            title="Короткий опис"
            value={shortDescription}
            setValue={(value) => setShortDescription(value)}
            isRequired
            isBig={true}
          />
          <EditInput
            title="Обʼєм"
            value={capacity}
            setValue={(value) => setCapacity(value)}
            isRequired
          />
          <EditInput
            title="Як користуватись"
            value={howToUse}
            setValue={(value) => setHowToUse(value)}
            isRequired
            isBig={true}
          />
          <EditInput
            title="Вартість"
            value={price}
            setValue={(value) => changePriceCount(value, setPrice)}
            isRequired
          />
          <EditInput
            title="Оптова вартість"
            value={wholeSalePrice}
            setValue={(value) => changePriceCount(value, setWholeSalePrice)}
            isRequired
          />
          <SelectInput
            title="Бренд"
            value={brand}
            values={props.brands.map((item) => ({
              value: item.id,
              label: item.name,
            }))}
            onChange={(value) => setBrand(value)}
          />
          <SelectInput
            title="Категорія"
            value={category}
            values={props.categories.map((item) => ({
              value: item.id,
              label: item.name,
            }))}
            onChange={(value) => setCategory(value)}
          />
          <SelectInput
            title="Тип"
            value={type}
            values={props.types.map((item) => ({
              value: item.id,
              label: item.name,
            }))}
            onChange={(value) => setType(value)}
          />
          <SelectInput
            title="Дісконт"
            value={discount}
            values={props.discounts.map((item) => ({
              value: item.id,
              label: item.percent,
            }))}
            onChange={(value) => setDiscount(value)}
          />
          <SelectInput
            title="Тип шкіри"
            value={skinType}
            onChange={(value) => setSkinType(value)}
            values={skinTypeSelector}
          />

          <EditInput
            title="Список інгридієнтів"
            value={fullIngredientsList}
            setValue={(value) => setFullIngredientsList(value)}
            isRequired
            isBig={true}
          />
          <SelectChangeListInput
            items={props.tags.map((item) => ({
              name: item.name,
              id: item.id,
            }))}
            title="Conditions"
            values={tags || []}
            isMultiSelect={true}
            onClickInactive={(value) =>
              setTags((prevState) => {
                if (prevState) {
                  return [...prevState, { ...value }];
                } else {
                  return [{ ...value }];
                }
              })
            }
            onClickActive={(value) =>
              setTags((prevState) => {
                if (prevState) {
                  return prevState.filter((item) => item.id !== value.id);
                }
              })
            }
          />
          {tags && (
            <ViewInput
              title="Conditions"
              value={tags.map((item) => item.name).join(", ")}
              isBig
            />
          )}
          <div className={styles.avalibleContainer}>
            <CustomRadioButton
              name="Опублікувати"
              label="Опублікувати"
              isChecked={avaliable}
              value={"Опублікувати"}
              onClick={() => setAvaliable(!avaliable)}
            />
          </div>
        </form>
        <ModalBottomButtons
          isDeleteBackButton={true}
          onPressApply={onClickApply}
          isApplyDisabled={isDisabled}
          applyTitle="Зберегти"
          onPressBack={props.onClose}
          backTitle="Видалити"
        />
      </>
    </div>
  );
};

export default EditProductForm;
